"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rightsPerRole = exports.ContextMembership = exports.Context = exports.fallbackSettingsMap = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
exports.fallbackSettingsMap = new Map([
    [network_constants_1.NetworkConstants.SETTING_COLLECTIVE_SPECIES, {
            identifier: network_constants_1.NetworkConstants.SETTING_COLLECTIVE_SPECIES,
            values: [
                { names: { de: "Krähe" }, sortOrder: 1, identifier: "Krähe" },
                { names: { de: "Taube" }, sortOrder: 1, identifier: "Taube" },
                { names: { de: "Fasan" }, sortOrder: 1, identifier: "Fasan" },
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_GR_LOCATION, {
            identifier: network_constants_1.NetworkConstants.SETTING_GR_LOCATION,
            values: [
                {
                    "identifier": "wildkammer",
                    "title": "Wildkammer"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_GR_STATUS, {
            identifier: network_constants_1.NetworkConstants.SETTING_GR_STATUS,
            values: [
                {
                    "identifier": "erfasst",
                    "title": "erfasst"
                },
                {
                    "identifier": "in Bergung",
                    "title": "in Bergung"
                },
                {
                    "identifier": "in Wildkammer",
                    "title": "in Wildkammer"
                },
                {
                    "identifier": "Verwertung",
                    "title": "in Verwertung"
                },
                {
                    "identifier": "verworfen",
                    "title": "verworfen"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_GEO_TYPE, {
            identifier: network_constants_1.NetworkConstants.SETTING_GEO_TYPE,
            values: [
                { identifier: "hochsitz", title: "Hochsitz", sortOrder: 0 },
                { identifier: "drueckjagdbock", title: "Drückjagdbock", sortOrder: 0 },
                { identifier: "drueckjagdstand", title: "Drückjagdstand", sortOrder: 0 },
                { identifier: "erdsitz", title: "Erdsitz", sortOrder: 0 },
                { identifier: "kanzel.geschlossen", title: "Kanzel (geschlossen)", sortOrder: 0 },
                { identifier: "kanzel.offen", title: "Kanzel (offen)", sortOrder: 0 },
                { identifier: "kanzel.schlafkanzel", title: "Kanzel (schlaf~)", sortOrder: 0 },
                { identifier: "kirrung", title: "Kirrung", sortOrder: 0 },
                { identifier: "leiter.offen.baum", title: "Leiter (offen, am Baum)", sortOrder: 0 },
                { identifier: "leiter.offen.frei", title: "Leiter (offen, freistehend)", sortOrder: 0 },
                { identifier: "salzlecke", title: "Salzlecke", sortOrder: 0 },
                { identifier: "wildkammer", title: "Wildkammer", sortOrder: 0 },
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_GEO_LINE_TYPES, {
            identifier: network_constants_1.NetworkConstants.SETTING_GEO_LINE_TYPES,
            values: [
                { identifier: "pirschweg", title: "Pirschweg2", sortOrder: 0 },
                { identifier: "wildwechsel", title: "Wildwechsel", sortOrder: 0 },
                { identifier: "fahrweg", title: "Fahrweg", sortOrder: 0 },
                { identifier: "fahrweg 1", title: "Fahrweg 1", sortOrder: 0 },
                { identifier: "fahrweg 2", title: "Fahrweg 2", sortOrder: 0 },
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_HUNTING_METHODS, {
            identifier: network_constants_1.NetworkConstants.SETTING_HUNTING_METHODS,
            values: [
                { identifier: "hideHunt", title: "Ansitzjagd", sortOrder: 0 },
                { identifier: "drivenHunt", title: "Drückjagd", sortOrder: 0 },
                { identifier: "stalking", title: "Pirschjagd", sortOrder: 0 },
                { identifier: "fallowGameAccident", title: "Fallwild: Unfall", sortOrder: 0 },
                { identifier: "fallowGameMisc", title: "Fallwild: Sonstige", sortOrder: 0 },
                { identifier: "chopper", title: "Mähverlust", sortOrder: 0 },
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_LOCATION, {
            identifier: network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_LOCATION,
            values: [
                {
                    "identifier": "wildkammer",
                    "title": "Wildkammer"
                },
                {
                    "identifier": "labor",
                    "title": "Labor"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_STATUS, {
            identifier: network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_STATUS,
            values: [
                {
                    "identifier": "erfasst",
                    "title": "erfasst"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_TYPE, {
            identifier: network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_TYPE,
            values: [
                {
                    "identifier": "trichinenTestGewebe",
                    "title": "Trichinen Test Gewebe"
                },
                {
                    "identifier": "bluttestAujeczky",
                    "title": "Bluttest Aujeczky"
                },
                {
                    "identifier": "bluttestAllgemein",
                    "title": "Bluttest Allgemein"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_GR_MEAT_QUALITY, {
            identifier: network_constants_1.NetworkConstants.SETTING_GR_MEAT_QUALITY,
            values: [
                { identifier: "Gut", title: "Gut", sortOrder: 0, comment: null }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_GR_SHOT_QUALITY, {
            identifier: network_constants_1.NetworkConstants.SETTING_GR_SHOT_QUALITY,
            values: [
                { identifier: "Gut", title: "Gut", sortOrder: 0, comment: null }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_SPECIES, {
            identifier: network_constants_1.NetworkConstants.SETTING_SPECIES,
            values: [
                {
                    "ageClassesFemale": {
                        "de": [
                            "Kalb",
                            "Schmaltier",
                            "Alttier"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Kalb",
                            "Schmalspießer",
                            "Hirsch"
                        ]
                    },
                    "iconName": "icnRotwild",
                    "identifier": "Rotwild",
                    "names": {
                        "de": "Rotwild"
                    },
                    "sortOrder": 1
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Kalb",
                            "Schmaltier",
                            "Alttier"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Kalb",
                            "Schmalspießer",
                            "Hirsch"
                        ]
                    },
                    "iconName": "icnDamwild",
                    "identifier": "Damwild",
                    "names": {
                        "de": "Damwild"
                    },
                    "sortOrder": 2
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Lamm",
                            "Schmalschaf",
                            "Altschaf"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Lamm",
                            "Jährling",
                            "Widder"
                        ]
                    },
                    "iconName": "icnMuffelwild",
                    "identifier": "Muffelwild",
                    "names": {
                        "de": "Muffelwild"
                    },
                    "sortOrder": 4
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Rickenkitz",
                            "Schmalreh",
                            "Ricke"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Bockkitz",
                            "Jährling",
                            "Bock"
                        ]
                    },
                    "iconName": "icnRehwild",
                    "identifier": "Rehwild",
                    "names": {
                        "de": "Rehwild"
                    },
                    "sortOrder": 6
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Frischlingsbache",
                            "Überläuferbache",
                            "Bache"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Frischlingskeiler",
                            "Überläuferkeiler",
                            "Keiler"
                        ]
                    },
                    "iconName": "icnSchwarzwild",
                    "identifier": "Schwarzwild",
                    "names": {
                        "de": "Schwarzwild"
                    },
                    "sortOrder": 5
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Kalb",
                            "Schmaltier",
                            "Alttier"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Kalb",
                            "Schmalspießer",
                            "Hirsch"
                        ]
                    },
                    "iconName": "icnSikawild",
                    "identifier": "Sikawild",
                    "names": {
                        "de": "Sikawild"
                    },
                    "sortOrder": 3
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Jungfuchsfähe",
                            "Fähe"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Jungfuchsrüde",
                            "Rüde"
                        ]
                    },
                    "iconName": "icnFuchs",
                    "identifier": "Fuchs",
                    "names": {
                        "de": "Fuchs"
                    },
                    "sortOrder": 7
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Jungdachsfähe",
                            "Dachsfähe"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Jungdachsrüde",
                            "Dachsbär"
                        ]
                    },
                    "iconName": "DIWIMA_Icons_Wildarten_Dachs",
                    "identifier": "Dachs",
                    "names": {
                        "de": "Dachs"
                    },
                    "sortOrder": 8
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Waschbär (adult)"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Jungtier"
                        ]
                    },
                    "iconName": "DIWIMA_Icons_Wildarten_Waschbaer",
                    "identifier": "Waschbär",
                    "names": {
                        "de": "Waschbär"
                    },
                    "sortOrder": 9
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Jungnutria Metze",
                            "Nutria Metze"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Jungnutria männlich",
                            "Nutria männlich"
                        ]
                    },
                    "iconName": "icnNutria",
                    "identifier": "Nutria",
                    "names": {
                        "de": "Nutria"
                    },
                    "sortOrder": 10
                },
                {
                    "ageClassesFemale": {
                        "de": [
                            "Alttier"
                        ]
                    },
                    "ageClassesMale": {
                        "de": [
                            "Jungtier"
                        ]
                    },
                    "iconName": "DIWIMA_Icons_Wildarten_Sonstige",
                    "identifier": "Sonstige",
                    "names": {
                        "de": "Sonstige"
                    },
                    "sortOrder": 11
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_UTILIZATION_OPTION, {
            identifier: network_constants_1.NetworkConstants.SETTING_UTILIZATION_OPTION,
            values: [
                {
                    "identifier": "eigen",
                    "title": "Eigenverwertung"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_TROPY_TYPE, {
            identifier: network_constants_1.NetworkConstants.SETTING_TROPY_TYPE,
            values: [
                {
                    "identifier": "antlers",
                    "title": "Geweih"
                },
                {
                    "identifier": "fur",
                    "title": "Fell"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_GEO_USAGE_STATUS, {
            identifier: network_constants_1.NetworkConstants.SETTING_GEO_USAGE_STATUS,
            values: [
                {
                    "identifier": "frei",
                    "title": "frei zur Verwendung"
                },
                {
                    "identifier": "ausnahmerecht",
                    "title": "Verwendung nur mit Ausnahmrecht"
                },
                {
                    "identifier": "nichtPositioniert",
                    "title": "vorübergehend nicht positioniert"
                },
                {
                    "identifier": "gesperrt.instandhaltung",
                    "title": "gesperrt - Instandhaltung ausstehend"
                },
                {
                    "identifier": "gesperrt",
                    "title": "gesperrt - bis auf weiteres"
                },
                {
                    "identifier": "vernichtet",
                    "title": "vernichtet"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_EVENT_INVITATION_SITE_REFERRAL, {
            identifier: network_constants_1.NetworkConstants.SETTING_EVENT_INVITATION_SITE_REFERRAL,
            values: []
        }],
    [network_constants_1.NetworkConstants.SETTING_READOUT_GROUPS, {
            identifier: network_constants_1.NetworkConstants.SETTING_READOUT_GROUPS,
            values: [
                {
                    "identifier": "Jagdgast",
                    "title": "Jagdgast"
                },
                {
                    "identifier": "Jagdhelfer",
                    "title": "Jagdhelfer"
                }
            ]
        }],
    [network_constants_1.NetworkConstants.SETTING_WORK_ORDER_TYPE, {
            identifier: network_constants_1.NetworkConstants.SETTING_WORK_ORDER_TYPE,
            values: []
        }],
]);
async function getContextSettings(firestore, contextId) {
    return new Promise(async (resolve, reject) => {
        try {
            var contextSettings = [];
            const settingsQuery = await firestore
                .collection(network_constants_1.NetworkConstants.COLLECTION_CONTEXT)
                .doc(contextId)
                .collection(network_constants_1.NetworkConstants.COLLECTION_SETTINGS)
                .get().toPromise();
            let map = new Map();
            if (!settingsQuery.empty) {
                settingsQuery.forEach((doc) => {
                    if (doc.exists) {
                        const data = doc.data();
                        if (data.values === "" || !data.values) {
                            data.values = [];
                        }
                        map.set(data.identifier, data);
                        contextSettings.push(doc.data());
                    }
                });
            }
            resolve(map);
        }
        catch (error) {
            console.log(error);
            reject(error);
        }
    });
}
async function getContextModules(firestore, contextId) {
    return new Promise(async (resolve, reject) => {
        try {
            var contextModules = [];
            const modulesQuery = await firestore
                .collection(network_constants_1.NetworkConstants.COLLECTION_CONTEXT)
                .doc(contextId)
                .collection(network_constants_1.NetworkConstants.COLLECTION_MODULES)
                .get().toPromise();
            let map = new Map();
            if (!modulesQuery.empty) {
                modulesQuery.forEach((doc) => {
                    if (doc.exists) {
                        const data = doc.data();
                        const identifier = doc.id;
                        map.set(identifier, data);
                        contextModules.push(doc.data());
                    }
                });
            }
            resolve(map);
        }
        catch (error) {
            reject(error);
        }
    });
}
class Context {
    constructor(identifier, name) {
        this.identifier = identifier;
        this.name = name;
        this.settingsMap = exports.fallbackSettingsMap;
        this.modulesMap = new Map([]);
        this._structureVersion = undefined;
        this.roles = undefined;
        this.demoContext = undefined;
        this.testDataCreated = undefined;
        this.huntingEventManagement = undefined;
        this.subContextIds = undefined;
        this.superContext = undefined;
        this.superContextIds = undefined;
        this.testData = undefined;
    }
    setFromAny(element) {
        const { _structureVersion, roles, demoContext, testDataCreated, huntingEventManagement, subContextIds, superContext, superContextIds, testData } = element;
        this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion;
        this.roles = roles ? roles : this.roles;
        this.demoContext = (demoContext != null) ? demoContext : this.demoContext;
        this.testDataCreated = testDataCreated ? (0, obejct_diff_1.isDate)(testDataCreated) ? testDataCreated : (0, obejct_diff_1.firestoreTimestampToDate)(testDataCreated) : this.testDataCreated;
        this.huntingEventManagement = huntingEventManagement ? huntingEventManagement : this.huntingEventManagement;
        this.subContextIds = subContextIds ? subContextIds : this.subContextIds;
        this.superContext = superContext ? superContext : this.superContext;
        this.superContextIds = superContextIds ? superContextIds : this.superContextIds;
        this.testData = testData ? testData : this.testData;
    }
    getContextSettings(firestore) {
        return new Promise(async (resolve, reject) => {
            try {
                const map = await getContextSettings(firestore, this.identifier);
                map.forEach((value, key) => {
                    if (value) {
                        this.settingsMap.set(key, value);
                    }
                });
                resolve(map);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getContextModules(firestore) {
        return new Promise(async (resolve, reject) => {
            try {
                const map = await getContextModules(firestore, this.identifier);
                map.forEach((value, key) => { this.modulesMap.set(key, value); });
                resolve(undefined);
            }
            catch (error) {
                reject(error);
            }
        });
    }
}
exports.Context = Context;
// export enum UserRole {
//   ADMIN = "admin", REVIERLEITER = "revierLeiter", 
//   USER = "user", ANSTELLER = "ansteller", 
//   HUNTER = "hunter", JAGDLEITER = "jagdLeiter"
// }
class ContextMembership {
    constructor() {
        this.settingsMap = exports.fallbackSettingsMap;
        this.modulesMap = new Map(undefined);
        this.subContextIds = undefined;
        this.superContext = undefined;
        this.superContextIds = undefined;
        this.testData = undefined;
    }
    setFromAny(element) {
        const { _structureVersion, roles, additionalRights, creationDate, updateTimestamp, huntingEventManagement, identifier, contextName, name, contextId, invitationState, userId, email, oobCode, subContextIds, superContext, superContextIds, testData } = element;
        this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion;
        this.identifier = identifier ? identifier : contextId ? contextId : this.identifier;
        this.contextName = contextName ? contextName : name ? name : this.contextName;
        this.roles = roles ? roles : this.roles;
        this.additionalRights = additionalRights ? additionalRights : this.additionalRights;
        this.updateTimestamp = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.creationDate = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.huntingEventManagement = huntingEventManagement ? huntingEventManagement : this.huntingEventManagement;
        this.invitationState = invitationState ? invitationState : this.invitationState;
        this.userId = userId ? userId : this.userId;
        this.email = email ? email : this.email;
        this.oobCode = oobCode ? oobCode : this.oobCode;
        this.subContextIds = subContextIds ? subContextIds : this.subContextIds;
        this.superContext = superContext ? superContext : this.superContext;
        this.superContextIds = superContextIds ? superContextIds : this.superContextIds;
        this.testData = testData ? testData : this.testData;
    }
    static setFromAny(element) {
        const contextMembership = new ContextMembership();
        contextMembership.setFromAny(element);
        return contextMembership;
    }
    isRoleMember(role) {
        var _a;
        if (!this.roles)
            return false;
        return ((_a = this.roles) === null || _a === void 0 ? void 0 : _a.includes(role.toString())) ? true : false;
    }
    getContextSettings(firestore) {
        return new Promise(async (resolve, reject) => {
            if (!this.identifier)
                reject('No contextId provided');
            try {
                const map = await getContextSettings(firestore, this.identifier);
                map.forEach((value, key) => {
                    if (value) {
                        this.settingsMap.set(key, (0, obejct_diff_1.deepCopy)(value));
                    }
                });
                resolve(map);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getContextModules(firestore) {
        return new Promise(async (resolve, reject) => {
            if (!this.identifier)
                reject('No contextId provided');
            try {
                const map = await getContextModules(firestore, this.identifier);
                map.forEach((value, key) => { this.modulesMap.set(key, value); });
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    }
    /**
       * Function for skipping objects and data while deepcopying class.
       * used as optional Input for deepCopy(any, replacerFn)
       * @param key
       */
    replacerFn(key) {
        if (key == "settingsMap")
            return false;
        else
            return true;
    }
    toString() {
        return JSON.stringify(this);
    }
}
exports.ContextMembership = ContextMembership;
exports.rightsPerRole = {
    revierLeiter: {
        cockpit: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`start`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`dashboard`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`dashcadenza`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`contextsettings`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`objects`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`invitation`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`statistics`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`map`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_GAMERECORD]: {
            C: true,
            R: true,
            U: true,
            D: true,
            E: true,
            I: true
        },
        [network_constants_1.NetworkConstants.COLLECTION_POI]: {
            C: true,
            R: true,
            U: true,
            D: true,
            E: true,
            I: true
        },
        [network_constants_1.NetworkConstants.COLLECTION_WORK_ORDER]: {
            C: true,
            R: true,
            U: true,
            D: true,
            E: true,
            I: true
        },
        [network_constants_1.NetworkConstants.COLLECTION_USER]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_HUNTING_DISTRICT]: {
            C: true,
            R: true,
            U: true,
            D: true,
            E: true,
            I: true
        },
        [network_constants_1.NetworkConstants.COLLECTION_GAME_COLLECT_STATION]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_EVENT]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_PERSON]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_DIGATAG]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_LABSAMPLE]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_TROPHY]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_LIFE_SIGN]: {
            C: true,
            R: true,
            U: true,
            D: true,
        }
    },
    [network_constants_1.NetworkConstants.COLLECTION_GAMERECORD]: {
        C: false,
        R: false,
        U: false,
        D: false,
        E: false,
        I: false,
        filter: {}
    },
    [network_constants_1.NetworkConstants.COLLECTION_HUNTING_DISTRICT]: {
        C: false,
        R: false,
        U: false,
        D: false,
        E: false,
        I: false,
        filter: {}
    },
    [network_constants_1.NetworkConstants.COLLECTION_POI]: {
        C: false,
        R: false,
        U: false,
        D: false,
        E: false,
        I: false,
        filter: {}
    },
    [network_constants_1.NetworkConstants.COLLECTION_WORK_ORDER]: {
        C: false,
        R: false,
        U: false,
        D: false,
        E: false,
        I: false,
        filter: {}
    },
    admin: {
        cockpit: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`start`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`dashboard`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`dashcadenza`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`contextsettings`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`objects`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`invitation`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`statistics`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`map`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [network_constants_1.NetworkConstants.COLLECTION_GAMERECORD]: {
            C: true,
            R: true,
            U: true,
            D: true,
            E: true,
            I: true
        },
        [network_constants_1.NetworkConstants.COLLECTION_POI]: {
            C: true,
            R: true,
            U: true,
            D: true,
            E: true,
            I: true
        },
        [network_constants_1.NetworkConstants.COLLECTION_WORK_ORDER]: {
            C: true,
            R: true,
            U: true,
            D: true,
            E: true,
            I: true
        },
    },
    cockpit: {
        cockpit: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`start`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
        [`dashboard`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`dashcadenza`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`contextsettings`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`objects`]: {
            C: false,
            R: true,
            U: false,
            D: false,
        },
        [`invitation`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`statistics`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`map`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_GAMERECORD]: {
            C: false,
            R: false,
            U: false,
            D: false,
            E: false,
            I: false,
            filters: []
        },
        [network_constants_1.NetworkConstants.COLLECTION_POI]: {
            C: false,
            R: false,
            U: false,
            D: false,
            E: false,
            I: false,
            filters: []
        },
        [network_constants_1.NetworkConstants.COLLECTION_WORK_ORDER]: {
            C: false,
            R: false,
            U: false,
            D: false,
            E: false,
            I: false
        },
        [network_constants_1.NetworkConstants.COLLECTION_USER]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_HUNTING_DISTRICT]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_GAME_COLLECT_STATION]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_EVENT]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_PERSON]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_DIGATAG]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_LABSAMPLE]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_TROPHY]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [network_constants_1.NetworkConstants.COLLECTION_LIFE_SIGN]: {
            C: false,
            R: false,
            U: false,
            D: false,
        }
    },
    smartmap: {
        cockpit: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`start`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`dashboard`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`dashcadenza`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`contextsettings`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`objects`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`invitation`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`statistics`]: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
        [`map`]: {
            C: true,
            R: true,
            U: true,
            D: true,
        },
    },
    ansteller: {
        cockpit: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
    },
    jagdleiter: {
        cockpit: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
    },
    user: {
        cockpit: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
    },
    hunter: {
        cockpit: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
    },
    recorder: {
        cockpit: {
            C: false,
            R: false,
            U: false,
            D: false,
        },
    }
};
